import css from 'classnames'
import { ReactNode } from 'react'

interface MaxWidthContainerProps {
  children: ReactNode
  className?: string
  maxWidthClassName?: string
}

export const MaxWidthContainer = ({
  children,
  className,
  maxWidthClassName = 'max-w-[1280px]',
}: MaxWidthContainerProps) => {
  return (
    <div className={css('mx-auto w-full', maxWidthClassName, className)}>
      {children}
    </div>
  )
}
